import { Injectable, Injector } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, Command } from '../../../core/model/command';
import { Observable, of, tap } from 'rxjs';
import { propertyCommand } from '../../command/property.command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { MovePropertyToCompanyDialogComponent } from '../../component/move-property-to-company-dialog/move-property-to-company-dialog.component';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class MoveToCompanyCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindowService: ActionWindowService,
    private _injector: Injector,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    return command.id === propertyCommand.moveToCompany;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command)
      return this._actionWindowService.open(MovePropertyToCompanyDialogComponent, this._injector, null, command.context).pipe(
        tap(res => {
          if (res) this._navigationService.reloadCurrentRoute();
        })
      );
  }
}
